import { Component, EventEmitter, Output } from '@angular/core';
import { ControlBase } from '../../../base/control-base/control-base.component';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
    selector: 'import-button-control',
    standalone: false,
    template: `
        <button class="btn" (click)="fileInput.click()">
            <img src="@imagesDir/import.png" />
            <span class="mx-1">{{ 'common.import' | translate }}</span>
        </button>
        <input
            #fileInput
            id="import-file-input"
            type="file"
            class="d-none"
            accept=".xlsx"
            (change)="onChange($event)" />
    `,
    styles: `
        button > img {
            width: 24px;
            height: 24px;
        }

        .btn span {
            writing-mode: horizontal-tb;
            text-orientation: mixed;
            display: inline;
        }
    `
})
export class ImportButtonControl extends ControlBase {
    constructor(protected override spinnerService: NgxSpinnerService) {
        super(spinnerService);
    }

    @Output() changed = new EventEmitter<any>();

    public onChange(event: any) {
        this.changed.emit(event);
    }
}
